import camelCaseKeys from 'camelcase-keys'

export class AccountCurrency {
  constructor (params = {}) {
    const {
      currency,
      balance,
      postpaid
    } = camelCaseKeys(params, { deep: true })
    this.currencyId = currency.id || null
    this.currency = currency || null
    this.balance = balance || 0
    this.postpaid = postpaid || false
  }
}
